import axios from "axios";
import { toast } from "sonner";
import { API, formatApiError } from "../auth/api";

/**
 * 2026-10-25: En medarbejder har mistet telefonen.
 *
 * - "Log ud på alle enheder": alle logins (også den mistede telefon) holder op
 *   med at virke med det samme. Næste login kræver adgangskoden (og 2FA, hvis
 *   den er slået til). Bruges til chauffører, kollegaer og lokations-admins.
 * - "Nulstil 2FA": koden fra telefonen og gendannelseskoderne slettes, og
 *   brugeren sætter 2FA op igen ved næste login (får en mail om det).
 *
 * Begge logges (security_audit). Super admin (support) kan gøre det for alle.
 */
export async function logoutEverywhere(u, onDone) {
  const who = u.name || u.email || "brugeren";
  if (!window.confirm(`Log ${who} ud på alle enheder?\n\nAlle logins - også på en mistet telefon - holder op med at virke med det samme. ${who} logger ind igen med sin adgangskode.`)) return;
  try { await axios.post(`${API}/users/${u.id}/logout-all`); toast.success(`${who} er logget ud på alle enheder`); onDone?.(); }
  catch (e) { toast.error(formatApiError(e)); }
}

export async function resetTwoFactor(u, onDone) {
  const who = u.name || u.email || "brugeren";
  if (!window.confirm(`Nulstil 2FA for ${who}?\n\n${who} logges ud og sætter 2FA op igen ved næste login med sin nye telefon (og får en mail om det).`)) return;
  try { await axios.post(`${API}/users/${u.id}/mfa-reset`); toast.success("2FA er nulstillet"); onDone?.(); }
  catch (e) { toast.error(formatApiError(e)); }
}
